'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true,
});

var _index = require('../../../_lib/buildMatchPatternFn/index.js');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../../../_lib/buildMatchFn/index.js');

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;

var matchEraPatterns = {
	narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i,
};
var parseEraPatterns = {
	any: [/^f/i, /^e/i],
};

var matchQuarterPatterns = {
	narrow: /^[1234]/i,
	abbreviated: /^q[1234]/i,
	wide: /^[1234](\.)? kvartal/i,
};
var parseQuarterPatterns = {
	any: [/1/i, /2/i, /3/i, /4/i],
};

var matchMonthPatterns = {
	narrow: /^[jfmasond]/i,
	abbreviated: /^(jan|feb|mar|apr|mai|jun|jul|aug|sep|okt|nov|des)\.?/i,
	wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i,
};
var parseMonthPatterns = {
	narrow: [
		/^j/i,
		/^f/i,
		/^m/i,
		/^a/i,
		/^m/i,
		/^j/i,
		/^j/i,
		/^a/i,
		/^s/i,
		/^o/i,
		/^n/i,
		/^d/i,
	],
	any: [
		/^ja/i,
		/^f/i,
		/^mar/i,
		/^ap/i,
		/^mai/i,
		/^jun/i,
		/^jul/i,
		/^aug/i,
		/^s/i,
		/^o/i,
		/^n/i,
		/^d/i,
	],
};

var matchDayPatterns = {
	narrow: /^[smtofl]/i,
	short: /^(sø|ma|ti|on|to|fr|lø)/i,
	abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
	wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i,
};
var parseDayPatterns = {
	any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i],
};

var matchDayPeriodPatterns = {
	narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
	any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i,
};
var parseDayPeriodPatterns = {
	any: {
		am: /^a(\.?\s?m\.?)?$/i,
		pm: /^p(\.?\s?m\.?)?$/i,
		midnight: /^midn/i,
		noon: /^midd/i,
		morning: /morgen/i,
		afternoon: /ettermiddag/i,
		evening: /kveld/i,
		night: /natt/i,
	},
};

var match = {
	ordinalNumber: (0, _index2.default)({
		matchPattern: matchOrdinalNumberPattern,
		parsePattern: parseOrdinalNumberPattern,
		valueCallback: function valueCallback(value) {
			return parseInt(value, 10);
		},
	}),

	era: (0, _index4.default)({
		matchPatterns: matchEraPatterns,
		defaultMatchWidth: 'wide',
		parsePatterns: parseEraPatterns,
		defaultParseWidth: 'any',
	}),

	quarter: (0, _index4.default)({
		matchPatterns: matchQuarterPatterns,
		defaultMatchWidth: 'wide',
		parsePatterns: parseQuarterPatterns,
		defaultParseWidth: 'any',
		valueCallback: function valueCallback(index) {
			return index + 1;
		},
	}),

	month: (0, _index4.default)({
		matchPatterns: matchMonthPatterns,
		defaultMatchWidth: 'wide',
		parsePatterns: parseMonthPatterns,
		defaultParseWidth: 'any',
	}),

	day: (0, _index4.default)({
		matchPatterns: matchDayPatterns,
		defaultMatchWidth: 'wide',
		parsePatterns: parseDayPatterns,
		defaultParseWidth: 'any',
	}),

	dayPeriod: (0, _index4.default)({
		matchPatterns: matchDayPeriodPatterns,
		defaultMatchWidth: 'any',
		parsePatterns: parseDayPeriodPatterns,
		defaultParseWidth: 'any',
	}),
};

exports.default = match;
module.exports = exports['default'];
